import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "../../../../components/ui/card";

const Members: React.FC = () => {
	const memberTypes = [
		{
			id: "regular",
			title: "一般メンバー",
			description: "学習ギルドの主要メンバー",
			details: [
				"年齢：18歳以上",
				"在住：大船渡市内外問わず",
				"参加費：無料（一部イベントは有料）",
				"特典：全イベントへの参加権、学習スペースの利用",
			],
		},
		{
			id: "student",
			title: "学生メンバー",
			description: "学生向けの特別枠",
			details: [
				"年齢：15歳以上",
				"在学：中学生以上",
				"参加費：無料",
				"特典：学生向けイベントの優先参加権",
			],
		},
		{
			id: "mentor",
			title: "メンター",
			description: "学習支援を行う経験者",
			details: [
				"経験：各分野3年以上",
				"役割：学習支援、イベント企画",
				"特典：メンター手当あり",
				"募集：随時（書類・面談選考あり）",
			],
		},
	];

	return (
		<section className="mb-16">
			<h2 className="text-3xl font-semibold mb-6">メンバー構成</h2>
			<div className="grid md:grid-cols-3 gap-6">
				{memberTypes.map((type) => (
					<Card key={type.id}>
						<CardHeader>
							<CardTitle>{type.title}</CardTitle>
							<CardDescription>{type.description}</CardDescription>
						</CardHeader>
						<CardContent>
							<ul className="list-disc list-inside space-y-2 text-sm text-gray-600">
								{type.details.map((detail) => (
									<li key={detail}>{detail}</li>
								))}
							</ul>
						</CardContent>
					</Card>
				))}
			</div>
		</section>
	);
};

export default Members;
